export default function removeTimezoneOffset(date) {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
}
